import {warn} from 'console'
import shift from 'store/reducers/shift'

const uk = {
  others: {
    generalStatistics: 'Загальна статистика',
    wpp: 'Вітряні електростанції (ВЕС)',
    spp: 'Сонячні електростанції (СЕС)',
    allWpp: 'Усі ВЕС',
    allSpp: 'Усі СЕС',
    WppSpp: 'ВЕС-СЕС',
    spp_nikopol: 'Нікопольська СЕС',
    spp_pokrovsk: 'Покровська СЕС',
    spp_trifanovsk: 'Тріфановська СЕС',
    wpp_tiligul: 'Тилігульська ВЕС',
    windPowerPlants: 'Вітряні електростанції (ВЕС)',
    solarPowerPlants: 'Сонячні електростанції (СЕС) ',
    dashboard: 'Дашборд',
    unbalance: 'Небаланс',
    powerBI: 'Power BI',
    forecasts: 'Прогнозування',
    map: 'Мапа',
    businessPlan: 'Бізнес план',
    users: 'Користувачі',
    restrictionsJournal: 'Журнал обмежень',
    restrictionsJournalCreate: 'Створення заявки',
    restrictionsJournalView: 'Перегляд заявки',
    restrictionsJournalEdit: 'Редагування заявки',
    forecastAndActualProduction: 'Прогнозна і фактична виробки (ВЕС, СЕС)',
    deviation: 'Відхилення',
    totalVariation: 'Сумарне відхилення',
    keyMetrics: 'Ключові метрики',
    liveData: 'Дані в реальному часі',
    budgetVsFact: 'Закладено в план і фактичні дані',
    generalUnbalanceTooltip: 'Позитивні і негативні небаланси, а також їх сума',
    unbalanceOutOfRangeTooltip:
      'Позитивні і негативні небаланси, які виходять за допустимий поріг, а також їх сума',
    percentageOfPredictionsTooltip:
      'Відсоток прогнозів які збулися в рамках допустимого порогу відхилень ',
    biasTooltip: 'Розбіжності між даними прогнозу і дійсними (фактичними) даними',
    nmaeTooltip: 'Нормалізована середня абсолютна помилка ',
    nrmseTooltip: 'Нормалізована середньоквадратична помилка',
    energyAvailabilityTooltip:
      'Енергетичний коефіцієнт готовності розраховується за повні календарні місяці, незалежно від обраних у фільтрі днів',
    bpNameAndDescriptionChanges: 'Назва БП та опис останніх змін',
    bpDate: 'Дата і час завантаження',
    bpAuthor: 'Автор',
    bpTemplate: 'Шаблон бізнес-плану',
    currentCapacity: 'Поточна потужність',
    projectCapacity: 'Проектна потужність',
    nestedListItems: 'Вкладені елементи списку',
    variationOfForecast: 'Відхилення прогнозного від фактичного виробітку',
    forecast: 'Прогнозний',
    actual: 'Фактично',
    station: 'Станція',
    namePlan: 'Бізнес план генерації ВЕС-СЕС',
    descriptionRecentChanges: 'Завантажено було:',
    Production: 'Виробництво',
    EnergyAvailability: 'Доступність енергії',
    WindResource: 'Вітровий ресурс',
    Insolation: 'Інсоляція',
    forecastHorizon: 'Горизонт прогнозу',
    Average: 'В середньому',
    'Guaranteed Buyer': 'Гарантований покупець',
    Model: 'Модель',
    Fact: 'Фактичні',
    startDateRDC: 'Дата і час отримання команди від диспетчера РДЦ на введення обмеження',
    powerCommandRestriction: 'Потужність команди обмеження, +/-, МВт',
    powerBefore: 'Потужність станції до введення обмеження, МВт',
    endDateRDC: 'Дата і час отримання команди від диспетчера РДЦ на зняття обмеження',
    duration: 'Тривалість обмеження, хв',
    powerAfter:
      'Потужність станції після виходу на необмеженої потужності при існуючих погодних умовах, МВт',
    lossesSCADA: 'Недовідпуск SCADA, МВтг',
    lossesCalculatedOrEtalon: 'Недовідпуск (розрахунковий або еталонний метод), МВт * год',
    positiveImbalance: 'Позитивний небаланс',
    negativeImbalance: 'Негативний небаланс',
    relativeUnbalanceIndex: 'Відносний показник небалансу',
    OperationalJournal: 'Оперативний журнал',
    OperationalJournalCreate: 'Створення запису',
    OperationalJournalView: 'Перегляд запису',
    OperationalJournalEdit: 'Редагування запису',
    OperationalJournalCreateRecord: 'Створення незалежного запису',
    OperationalJournalShiftTransfer: 'Передача зміни',
    OperationalJournalShiftAcceptance: 'Приймання зміни',
    OperationalJournalShiftsHistoryDetails: 'Перегляд історії передачі зміни',
    Administration: 'Адміністрування',
    AdministrationCreate: 'Додати нового користувача',
    AdministrationEdit: 'Редагування даних користувача',
    AdministrationView: 'Перегляд даних користувача',
    peopleId: 'ID користувача',
    email: 'Пошта',
    name: "Ім'я",
    surname: 'Прізвище',
    role: 'Роль',
    location: 'Локація',
    admin: 'Адміністратор',
    stationShiftSupervisor: 'Начальник зміни станції',
    user: 'Оглядач',
    analyst: 'Аналітик',
    stationAnalyst: 'Аналітик станції',
    stationDirector: 'Директор станції',
    searchPlaceholder: 'Пошук...',
    noData: 'Немає даних для відображення',
  },
  infoMessages: {
    selectedPeriodNotMultipleCalendarWeek:
      'Ви обрали період, який не кратний календарному тижню. Показники NMAE, NMRSE і bias будуть відображені некоректно',
    loadingPleaseWait: 'Зачекайте, триває завантаження',
    notAccess: 'Ця сторінка не відповідає правам доступу',
    connectSupport:
      'Зверніться до<supportLink>{{supportService}}</supportLink> для контролю доступу та відображення даних',
    supportService: 'служби підтримки',
    supportEmail: 'support@dtek.com',
    supportEmailSubject: 'Права доступу до системи контролю WatchTower',
    dataLoadingError: 'Помилка завантаження даних',
    errorLoadingFile: 'Помилка завантаження файлу',
    errorLoadingDateEmptyData: 'Помилка завантажити дат, за які присутні дані',
    errorLoadingListForecasters: 'Помилка завантаження списку прогнозистів',
    bPSuccess: 'Файл бізнес-плану успішно оновлено',
    updatingData: 'Оновлення даних',
    fileError: 'Помилка в файлі',
    fileWarningDuplicate: 'Дублювання даних у файлі',
    uploadBpFileValidationError:
      'Оновлюваний файл не відповідає вимогам шаблону. Наявна помилка в комірці: {{invalidCellAddress}}',
    uploadBpFileParseError: 'Помилка обробки файлу бізнес-плану: {{parseErrorMessage}}',
    uploadBpFileRowsValidationError:
      'Помилка структури файлу: Невалідна структура файлу або кількість рядків.',
    uploadBpFileReadError: 'Помилка читання файлу. Перевірте формат файлу',
    uploadBpFileRequiredCellsMessage:
      "Перед завантаженням файлу переконайтеся, що всі обов'язкові для заповнення комірки містять дані.",
    uploadedBpFileDuplicateMessage:
      'Параметри завантаженого бізнес-плану повністю збігаються з попереднім',
    generalImbalance: 'Загальний небаланс',
    totalDeviation: 'Сумарне відхилення',
    title404: 'Сторінка, яку Ви шукаєте, не існує або була видалена',
    desc404_1: 'Спробуйте почати свій шлях з',
    desc404_2: 'головної сторінки',
    dataUpdateSuccess: 'Зміни успішно додані',
    deleteData: 'Запис успішно видалено',
    dataUpdateError: 'Зміни не додані. Зверніться до служби підтримки для вирішення проблеми',
    dataCreateError:
      'Помилка створення запису. Зверніться до служби підтримки для вирішення проблеми',
    dataCreateSuccess: 'Запис успішно створено',
    shiftTransferError:
      'Помилка завантаження зміни. Зверніться до служби підтримки для вирішення проблеми',
    sendShiftTransferSuccess: 'Зміну успішно передано',
    sendShiftTransferError:
      'Помилка передачі зміни. Зверніться до служби підтримки для вирішення проблеми',
    shiftAcceptanceError:
      'Помилка завантаження даних приймання зміни. Зверніться до служби підтримки для вирішення проблеми',
    acceptShiftSuccess: 'Зміну успішно прийнято',
    acceptShiftError:
      'Помилка приймання зміни. Зверніться до служби підтримки для вирішення проблеми',
    equipmentCreateError:
      'Помилка створення устаткування. Зверніться до служби підтримки для вирішення проблеми',
    equipmentCreateSuccess: 'Устаткування успішно створено',
    editRequestSendSuccess: 'Запит на редагування запису надіслано',
    editRequestSendConflict: 'Запит на редагування вже було надіслано',
    editRequestAcceptSuccess: 'Запит на редагування запису погоджено',
    editRequestRejectWarning: 'Дозвіл на редагування запису не надано',
    internalErrorTitle: 'Щось пішло не так...',
    internalErrorSubtitle:
      "Дані не вдалося завантажити. Спробуйте оновити сторінку або перевірити з'єднання з інтернетом.",
  },
  btn: {
    ok: 'Ok',
    save: 'Зберегти',
    cancel: 'Скасувати',
    continue: 'Продовжити',
    downloadTemplate: 'Скачати шаблон',
    updateBP: 'Оновити БП',
    downloadBP: 'Скачати поточні показики БП',
    delete: 'Видалити',
    edit: 'Редагувати',
    not: 'Ні',
    yes: 'Так',
    send: 'Надіслати',
    understood: 'Зрозуміло',
    confirm: 'Підтвердити',
    update: 'Оновити',
  },
  unit: {
    mw: 'МВт',
    kWh: 'кВт*год',
    wm2: 'Вт/м²',
    mc: 'м/с',
    mWH: 'мВт•год',
    kilowatt: 'КВт',
    kilowattMeter2: 'кВт/м²',
    percentageFell: 'Відсоток прогнозів який потрапив у межі нормальної роботи',
    hour: 'година',
    hours: 'години',
  },
  date: {
    today: 'Сьогодні',
    lastWeek: 'Минулий тиждень',
    currentWeek: 'Поточний тиждень',
    prevWeek: 'Попередній тиждень',
    currentMonth: 'Поточний місяць',
    PrevMonth: 'Попередній місяць',
    lastYear: 'Минулий рік',
    currentYear: 'Поточний рік',
    from: 'З',
    to: 'По',
    titleDRP: 'Виберіть період',
    hour: 'година',
    hours: 'години',
    calendar: 'Календар',
    year: 'Рік',
    weekToDate: 'З початку тижня',
    monthToDate: 'З початку місяця',
    yearToDate: 'З початку року ',
  },
  powerBI: {
    bp_imbalances: 'БП / Небаланси',
    reports: 'Деталізовані звіти',
    openPowerBI: 'Відкрити PowerBI у новій вкладці',
  },
  operationalJournal: {
    currentShift: 'Поточна зміна - {{shiftName}}',
    dateLastChange: 'Дата і час останнього редагування: {{lastUpdatedAt}}',
    applyFilter: 'Застосувати',
    filtering: 'Фільтрація',
    clear: 'Очистити',
    recordsPerPage: 'Записів журналу на сторінці',
    createRecord: 'Створити запис',
    transferShift: 'Передати зміну',
    acceptShift: 'Прийняти зміну',
    operationalLabel: 'Оперативний запис',
    commentLabel: 'Коментар',
    plantLabel: 'Електростанція',
    recordType: 'Тип запису',
    equipmentObjects: "Об'єкти",
    equipmentObject: "Об'єкт",
    addEquipmentPlaceholder: 'Додати устаткування',
    createEquipment: 'Створити устаткування',
    equipment: 'Устаткування',
    voltageClasses: 'Клас напруги, кВ',
    electricalSystems: 'Електроустановка',
    equipmentTypes: 'Обладнання',
    electricalConnections: 'Приєднання',
    dispatchNames: 'Диспетчерське найменування',
    describeEvent: 'Опис події',
    familiarization: 'Ознайомлення',
    eventTimeAndDate: 'Дата і час події',
    fullName: 'ПІБ співробітника',
    deviation: 'Відхилення від схеми нормального режиму',
    noDataSubtitle: 'В оперативний журнал ще не додано жодного запису',
    noFilterResults: 'Відсутні результати, що відповідають критеріям фільтрації.',
    noFilterResultsSubtitle: 'Оберіть інші параметри для фільтрації записів',
    noShiftsHistorySubtitle: 'Відсутні прийняті зміни',
    shiftsHistoryDetailTitle: 'Деталі передачі зміни',
    logDateAccepting: 'Дата і час приймання зміни',
    logDateTransfer: 'Дата і час передачі зміни',
    acceptanceDateFilter: 'Дата приймання зміни',
    transferDateFilter: 'Дата передачі зміни',
    fromDate: 'Початкова дата',
    toDate: 'Кінцева дата',
    eventDate: 'Дата події',
    eventTime: 'Час події',
    earthing: {
      label: 'Заземлення',
      InstallingPortable: 'Встановлення переносного заземлення',
      RemovingPortable: 'Зняття переносного заземлення',
    },
    limitation: {
      label: 'Обмеження',
      Introduction: 'Введення обмеження',
      Removal: 'Зняття обмеження',
    },
    tabs: {
      logs: 'Список записів',
      shiftsHistory: 'Історія передачі змін',
      details: 'Детальна інформація',
      changeLogHistory: 'Історія змін запису',
    },
    history: {
      updatedAt: 'Дата і час зміни запису',
      action: 'Виконані дії',
      oldValue: 'Попереднє значення',
      newValue: 'Нове значення',
      signer: 'Виконавець',
      noData: 'Немає даних про зміни',
    },
    dialogs: {
      unsavedChanges: {
        title: 'Попередження про втрату даних',
        subtitle: 'Ви збираєтесь змінити тип запису',
        description: 'Всі незбережені зміни будуть втрачені. Ви впевнені, що хочете продовжити?',
      },
      cancelSaveRecord: {
        title: 'Попередження про втрату даних',
        subtitle: 'Ви збираєтесь скасувати збереження запису',
        description: 'Якщо ви скасуєте збереження, це призведе до втрати усіх введених даних',
      },
      createEquipment: {
        title: 'Створення устаткування',
      },
      cancelCreateEquipment: {
        title: 'Попередження про втрату даних',
        subtitle: 'Ви збираєтесь скасувати створення устаткування',
        description: 'Якщо ви скасуєте створення, це призведе до втрати усіх введених даних',
      },
      existEquipment: {
        title: 'Устаткування вже існує',
        subtitle:
          'Для цього устаткування неможливо виконати збереження, оскільки запис із такою комбінацією полів вже існує в системі.',
        description:
          'Будь ласка, змініть значення одного або кількох полів, щоб створити унікальне устаткування',
      },
      confirmSaveChanges: {
        title: 'Ви збираєтесь зберегти запис',
        subtitle: 'Переконайтеся, що перелік обраного устаткування є актуальним.',
        description: 'Після збереження запису змінити вміст поля «Устаткування» буде неможливо',
      },
      confirmSendEditRequest: {
        title: 'Редагування запису недоступне',
        subtitle: 'Минуло 24 години з моменту створення запису',
        description:
          'Щоб внести зміни у запис, надішліть запит на його редагування уповноваженій особі',
      },
    },
    deviationNotification:
      'Зміна стану ознаки "Відхилення від схеми нормального режиму" вплине на обов\'язковість передачі події по зміні',
    operationalUnavailable: 'Оперативний запис недоступний',
    operationalUnavailableDescription: 'Прийміть зміну, щоб створити оперативний запис',
    editRequestApproval: {
      pendingBannerText:
        '{{name}} надіслав(ла) Вам запит на редагування запису оперативного журналу',
      approveButton: 'Погодити',
      rejectButton: 'Відхилити',
      alreadyProcessedTitle: 'Запит уже оброблено',
      approvedByOther: 'Запит на редагування цього запису було схвалено',
      rejectedByOther: 'Запит на редагування цього запису було відхилено',
      approvedByMe: 'Запит на редагування цього запису було схвалено Вами',
      rejectedByMe: 'Запит на редагування цього запису було відхилено Вами',
      authorizedPerson: 'Уповноважена особа: {{name}}',
      permissionGranted: 'Дозвіл на редагування запису надано',
      permissionDenied: 'Дозвіл на редагування запису не надано',
    },
  },
  shiftTransfer: {
    title: 'Ви розпочинаєте передавання зміни',
    description:
      'Будь ласка, переконайтесь, що перелік подій з ознакою “Відхилення від схеми нормального режиму” актуальний. За потреби оновіть статус цієї ознаки.',
    recipientEmployeeLabel: 'ПІБ працівника, якому передається зміна',
    permitToWorkLabel: 'Наряд-допуск',
    switchingOrderLabel: 'Бланк перемикання',
    deviationEventsLabel: 'Події, пов’язані з відхиленням від схеми нормального режиму',
    otherEventsLabel: 'Інші події',
    transferShiftButton: 'Передати зміну',
    noAddedEvents: 'Не додано подій',
    noAddedEventsInCurrentTime:
      'На даний момент, коли зміна здавалась, не було додано жодної події',
    dialogs: {
      cancelSaveRecord: {
        title: 'Попередження про втрату даних',
        subtitle: 'Ви збираєтесь скасувати передавання зміни',
        description: 'Якщо процес буде скасовано, це призведе до втрати усіх введених даних',
      },
      returnToNormalOperation: {
        title: 'Повернення до схеми нормального режиму',
        subtitle: 'З даного запису буде знято ознаку "Відхилення від схеми нормального режиму"',
        description: 'Після підтвердження запис буде переміщено до категорії "Інші події"',
      },
      deviationsFromNormalOperation: {
        title: 'Відхилення від схеми нормального режиму',
        subtitle: 'Даному запису буде присвоєно ознаку "Відхилення від схеми нормального режиму"',
        description:
          'Після підтвердження запис буде переміщено до категорії "Події, пов’язані з відхиленням від схеми нормального режиму"',
      },
      deviationConflict: {
        title: 'Дані оновлено',
        subtitle:
          'Перелік подій, пов’язаних з відхиленням від схеми нормального режиму, змінено в результаті дій іншого користувача',
        description: 'Оновіть сторінку, щоб відобразити актуальні дані',
      },
    },
  },
  shiftAcceptance: {
    warningText:
      'Перед підтвердженням прийняття зміни, будь ласка, перегляньте всі події та відмітьте ті, з якими ви ознайомились. Після прийняття зміни відповідальність за ці події переходить до вас.',
    title: 'Ви розпочинаєте приймання зміни',
    senderLabel: 'Зміну здав',
    permitToWorkLabel: 'Наряд-допуск',
    switchingOrderLabel: 'Бланк перемикання',
    deviationEventsLabel: 'Події, пов’язані з відхиленням від схеми нормального режиму',
    otherEventsLabel: 'Інші події',
    acceptShiftButton: 'Прийняти зміну',
    noAddedEvents: 'Не додано подій',
    eventsToFamiliarize: 'Ознайомтесь та підтвердіть події перед тим, як прийняти зміну',
    acceptShiftTooltip:
      'Кнопка активується тільки після усвідомленого підтвердження перегляду всіх подій',
  },
  validations: {
    required: 'Обов’язкове поле',
    maxLength4: 'Максимальна довжина 4 символи',
    maxLength500: 'Максимальна довжина 500 символів',
    atLeastOneEquipment: 'Потрібно додати хоча б одне устаткування',
    invalidDate: 'Невалідна дата',
    invalidTime: 'Невалідний час',
  },
  common: {
    yes: 'Так',
    no: 'Ні',
  },
  routerConfirmationDialog: {
    title: 'Попередження про втрату даних',
    youAreGoingToLeave: 'Ви збираєтесь вийти зі сторінки',
    changesWillBeLost: 'Якщо ви вийдете зі сторінки, це призведе до втрати усіх введених даних',
  },
}

export default uk
